export default [
    {path: '/nopermission', component: () => import('@/views/manager/noPermission.vue') },
    // {path: '/eduManage', component: () => import('@/views/manager/eduManager.vue') },
    // {path: '/depostManage', component: () => import('@/views/manager/depostManager.vue') },
    // {path: '/schoolManage', component: () => import('@/views/manager/schoolManager.vue') },
]